import { Moment } from 'moment';
import { DateModel } from '@platform500services/p500-ui-kit';
import moment from 'moment';

interface Range {
  value: DateModel<Moment>;
  title: string;
  isCollapsed?: boolean;
}

interface RangesModel {
  [propName: string]: Range;
}

const transformRange: RangesModel = {
  'this-month': {
    value: {
      from: moment().utc().startOf('month'),
      to: moment().utc().endOf('day'),
    },
    title: $localize`:@@dates.this_month:This Month`,
  },
  yesterday: {
    value: {
      from: moment().utc().subtract(1, 'day').startOf('day'),
      to: moment().utc().subtract(1, 'day').endOf('day'),
    },
    title: $localize`:@@dates.yesterday:Yesterday`,
    isCollapsed: true,
  },
  today: {
    value: {
      from: moment().utc().startOf('day'),
      to: moment().utc().endOf('day'),
    },
    title: $localize`:@@dates.today:Today`,
  },
  'week-to-date': {
    value: {
      from: moment().utc().startOf('isoWeek'),
      to: moment().utc().endOf('day'),
    },
    title: $localize`:@@dates.this_week:This Week`,
    isCollapsed: true,
  },
  'year-to-date': {
    value: {
      from: moment().utc().startOf('year'),
      to: moment().utc().endOf('day'),
    },
    title: $localize`:@@dates.this_year:This Year`,
  },
  'last-month': {
    value: {
      from: moment().utc().subtract(1, 'month').startOf('month'),
      to: moment().utc().subtract(1, 'month').endOf('month'),
    },
    title: $localize`:@@dates.last_month:Last Month`,
    isCollapsed: true,
  },
  'last-week': {
    value: {
      from: moment().utc().subtract(1, 'weeks').startOf('isoWeek'),
      to: moment().utc().subtract(1, 'weeks').endOf('isoWeek'),
    },
    title: $localize`:@@dates.last_week:Last Week`,
    isCollapsed: true,
  },
};

export type IIntervals =
  | 'last-hour'
  | '6-hours'
  | '12-hours'
  | 'this-month'
  | 'yesterday'
  | 'today'
  | 'week-to-date'
  | 'year-to-date'
  | 'last-month'
  | 'last-week';

export type ICurrentInterval = IIntervals | '';

export interface IRange {
  value: () => DateModel<Moment>;
  title: string;
}

export { RangesModel, transformRange };
